export const RACE_STATES = {
  DNS: 2,
  DNF: 3,
  RACING: 4,
  FINISHED: 5,
};

export const START_TYPES = {
  MASS: 0,
  CHASING: 1,
}

export const FINISH_TYPES = {
  FUNNEL: 0,
  CHECKPOINT: 1,
  COMBINED: 2,
}
export const DEFAULT_RACE_STATUS = RACE_STATES.RACING;
